/**
 * Internacionalización de la interfaz (react-i18next, exigido por Framework.md).
 *
 * IMPORTANTE: esto afecta SOLO a la interfaz. El PDF del DeCA se genera siempre
 * en español, con independencia del idioma elegido (apdo. 9.4): es el documento
 * que se presenta a la inspección española.
 */

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import es from './es.json'
import en from './en.json'

export const IDIOMAS = [
  { codigo: 'es', nombre: 'Español' },
  { codigo: 'en', nombre: 'English' },
] as const

const CLAVE_IDIOMA = 'dox.idioma'

void i18n.use(initReactI18next).init({
  resources: {
    es: { translation: es },
    en: { translation: en },
  },
  lng: localStorage.getItem(CLAVE_IDIOMA) ?? 'es',
  fallbackLng: 'es',
  interpolation: { escapeValue: false },
})

export function cambiarIdioma(codigo: string): void {
  localStorage.setItem(CLAVE_IDIOMA, codigo)
  void i18n.changeLanguage(codigo)
}

export default i18n
